// extracted by mini-css-extract-plugin
export default {"header":"search-results-header_header__gaa6x","small":"search-results-header_small__2vSuw"};